import { size } from 'lodash';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { emitter } from '../../../utils/emitter';
import _ from 'lodash'; // thu vien giup cac hang viet ngan gon hon
class ModalEditCountry extends Component {

    constructor(props) {
        super(props);
        this.state = {
            categoryName: '',
            categoryCountry: '',
            categoryLevel: '',
            categoryParentId: ''
        }

    }

    componentDidMount() {
        // console.log('Did mount edit Country: ', this.props.currentCountry)
        let category = this.props.currentCategory;
        if (category && !_.isEmpty(category)) {
            this.setState({
                categoryName: category.categoryName,
                categoryCountry: category.categoryCountry,
                categoryLevel: category.categoryLevel,
                categoryParentId: category.categoryParentId,
                id: category.id
            })
        }
    }
    toggle = () => {
        this.props.tooglefromParent()
    }
    handleOnchangeInput = (event, id) => {
        // bad code this.state[id] = event.target.value , ko nen update truc tiep
        // good code, thong qua 1 bien trung gian
        let copyState = { ...this.state }; // copy state moi
        copyState[id] = event.target.value
        this.setState({
            ...copyState
        }, () => { // callback function

        })
        // console.log("copyState: ", copyState)
        // console.log(event.target.value, id)
    }
    checkValideInput = () => {
        let arrInput = ['categoryName', 'categoryCountry', 'categoryLevel', 'categoryParentId'];
        let isValide = true;
        for (let i = 0; i < arrInput.length; i++) { // neu dung vong lap MAP thi ko the dung break, foreach

            if (!this.state[arrInput[i]]) {
                isValide = false
                alert("Missing parameters" + arrInput[i]);
                break;
            }
        }
        return isValide
    }
    handleEditCategory = () => {
        let isValide = this.checkValideInput();
        if (isValide == true) {
            this.props.editCurrentCategory(this.state)
        }


        // console.log("data modal edit Country: ", this.state)
    }

    render() {
        // console.log('check child props:', this.props);
        // console.log('check child open modal:', this.props.currentCountry);
        return (
            <Modal
                isOpen={this.props.isOpen}
                toggle={this.toggle}
                className="modal-category-container"
                size="lg"
                centered
            >
                <ModalHeader toggle={this.toggle}>Edit Category</ModalHeader>
                <ModalBody>
                    <div className='modal-category-body'>

                        <div className='input-container'>
                            <label>Email: </label>
                            <input
                                type="text"
                                name="categoryName"
                                placeholder="Enter category"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'categoryName')
                                }}
                                value={this.state.categoryName}

                            />
                        </div>
                        <div className='input-container'>
                            <label>Country: </label>
                            <select
                                name="categoryCountry"
                                id="categoryCountry"
                                class="form-control"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'categoryCountry')
                                }}
                            >
                                <option selected>Choose Country</option>
                                {this.props.countries && this.props.countries.map((item, index) => {
                                    // console.log('check map', item, index);
                                    return (
                                        <option value={item.id}> {item.countryName} </option>

                                    )
                                })}
                            </select>
                        </div>
                    </div>
                    <div className='modal-category-body'>
                        <div className='input-container'>
                            <label>Parent ID: </label>
                            <input
                                type="text"
                                name="categoryParentId"
                                placeholder="Enter parent ID"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'categoryParentId')
                                }}
                                value={this.state.categoryParentId}
                            />
                        </div>
                        <div className='input-container'>
                            <label>Level: </label>
                            <input
                                type="text"
                                name="categoryLevel"
                                placeholder="Enter level"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'categoryLevel')
                                }}
                                value={this.state.categoryLevel}
                            />
                        </div>
                    </div>

                </ModalBody>
                <ModalFooter>
                    <Button className='px-2' color="primary" onClick={this.handleEditCategory}>Save</Button>{' '}
                    <Button className='px-2' color="secondary" onClick={this.toggle}>Close</Button>
                </ModalFooter>
            </Modal>
        )
    }

}

const mapStateToProps = state => {
    return {
    };
};

const mapDispatchToProps = dispatch => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalEditCountry);


